<div class="sidebar" [ngClass]="{ 'sidebar-collapsed': isSidebarCollapsed }">
  <button class="sidebar-toggle-btn" [ngClass]="{ 'sidebar-collapsed': isSidebarCollapsed }"
    (click)="onSidebarToggle()">
    <i class="pi" [ngClass]="isSidebarCollapsed ? 'pi-angle-right' : 'pi-angle-left'"></i>

  </button>

  <div class="sidebar-menu">
    <ul>
      @for (item of menuItems; track item) {
      <li class="sidebar-menu-item ">
        <a [routerLink]="item.route" class="sidebar-item "
          [ngClass]="{ 'sidebar-item-active': activeRoute === item.route }">
          @if (item.iconType === 'mat') {
          <i class="pi sidebar-item-icon" [ngClass]="'pi-' + item.icon"></i>
          }
          @if (item.iconType === 'other') {
          <img class="sidebar-item-icon" [src]="item.icon" alt="{{ item.label }}" width="24" height="24" />
          }
          <span class="sidebar-item-text">{{ item.label }}</span>
        </a>
      </li>
      }
    </ul>
  </div>
</div>